










































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * API
 */
import settingsAPI from '@/api/settings';

/**
 * Components
 */
import SettingsEditor from './components/Editor.vue';

/**
 * Types
 */
import { SettingsCategories } from '@/api/settings';

/**
 * Page des configurations avancées.
 */
@Component({ components: { SettingsEditor }, mixins: [mixinsAPI] })
export default class AdvancedSettingsPage extends Vue {
	$refs!: {
		editor: SettingsEditor,
	};

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	isLoading = false;
	syncSettings: any = null;
	sendTestMailAddress: string = "";
	isTestLoading = false;

	get isTyping() {
		return this.$refs.editor.canSave;
	}

	/** Méthodes */
	async created() {
		this.isLoading = true;
		this.syncSettings = await settingsAPI.getSyncSettings();
		this.isLoading = false;
	}

	async fetchSettings() {
		return await settingsAPI.getAllSettings(SettingsCategories.ADVANCED_PARAMETER);
	}

	async saveSettings(formData: FormData) {
		return await settingsAPI.saveAllSettings(formData);
	}

	async sendTestEmail() {
		this.isTestLoading = true;
		try {
			await settingsAPI.sendTestEmail(this.sendTestMailAddress);
			this.openInfo(this.$t('snackbar.success'));
		}
		catch (err) {
			(this as any).handleAPIError(err);
		}
		this.isTestLoading = false;
	}
}
